.stats-container {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding-left: 24px;
    justify-content: center;
    min-width: 150px;
}
